import React, { ReactNode } from 'react';
import { AppShell, Box } from '@mantine/core';

interface PublicLayoutProps {
  children: ReactNode;
}

/**
 * パブリックページ専用の軽量レイアウト
 * 認証不要の外部向けページ（事前登録など）に使用
 *
 * 特徴：
 * - AuthProvider、SidebarProvider などの Context 不要
 * - サイドバー、ヘッダー、フッターなし
 * - フル幅レスポンシブコンテナ
 * - 公式サイト準拠の背景色（薄いシアン #f0f9fc）
 */
export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <AppShell
      padding={0}
      styles={{
        main: {
          minHeight: '100vh',
          height: '100vh',
          background: '#f0f9fc',
          padding: 0,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        style={{
          width: '100%',
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {children}
      </Box>
    </AppShell>
  );
};
